import { Children, PropsWithChildren, useMemo } from 'react'
import Box, { BoxProps } from 'components/shared/Box'
import IconWithText from 'components/shared/IconWithText'
import roundedCheckBlue from 'assets/icons/roundedCheckBlue.svg'
import roundedCheckViolet from 'assets/icons/roundedCheckViolet.svg'

export type CheckedIconVariantType = 'blue' | 'violet'

interface CheckedListProps extends BoxProps {
    iconVariant?: CheckedIconVariantType
}

const CheckedList = ({
    iconVariant,
    children,
    ...props
}: PropsWithChildren<CheckedListProps>) => {
    const arrayChildren = Children.toArray(children)

    const icon = useMemo(
        () =>
            iconVariant === 'violet' ? roundedCheckViolet : roundedCheckBlue,
        [iconVariant]
    )

    return (
        <Box
            direction="column"
            gap={[12, 16]}
            wrap="wrap"
            isFullWidth
            {...props}
        >
            {arrayChildren.map((child, childIndex) => (
                <IconWithText
                    gap={12}
                    fontVariant="body"
                    text={child}
                    icon={icon}
                    align="flex-start"
                    key={`listItem${childIndex}`}
                />
            ))}
        </Box>
    )
}

export default CheckedList
